/**
 * Coordonnées du tunnel de réservation conservées dans `sessionStorage`.
 *
 * Pourquoi ce module existe : en production le 2026-08-01, l'écran de
 * confirmation a affiché DEUX FOIS l'adresse du client précédent sur le même
 * appareil. La cause est lisible dans le navigateur — la déconnexion ne
 * nettoyait pas `flowcut_sensitive_data`, et `resolveBookingContact` privilégie
 * délibérément ce que le client a saisi sur ce que dit le compte. Pour deux
 * personnes qui réservent depuis le même poste (couple, famille, tablette de
 * l'accueil), la confirmation de la seconde partait à l'adresse de la première.
 *
 * La purge est déclenchée à deux moments, et deux seulement : la déconnexion et
 * le changement de compte. ⚠️ Surtout PAS sur l'événement `SIGNED_OUT` de
 * supabase : `ClientAuthPanel` fait un `signOut` volontaire au milieu du tunnel
 * de code par courriel (barrière du 28-07), sans qu'aucune personne ne change.
 */
export const BOOKING_CONTACT_STORAGE_KEY = "flowcut_sensitive_data";

/**
 * Événement diffusé après la purge du stockage.
 *
 * Sur le web, une déconnexion recharge la page entièrement (`leaveToPublicRoute`),
 * donc l'état React disparaît de lui-même. Sur mobile (Capacitor) la
 * déconnexion est une simple navigation SPA : `BookingContext` garde alors les
 * coordonnées EN MÉMOIRE et son effet d'auto-sauvegarde les réécrirait aussitôt
 * dans le stockage qu'on vient de vider. Cet événement lui dit de les lâcher.
 *
 * Un événement plutôt qu'un appel direct : `AuthContext` n'a pas à connaître
 * `BookingContext`, et `BookingProvider` reste montable seul dans les tests.
 */
export const BOOKING_CONTACT_CLEARED_EVENT = "flowcut:booking-contact-cleared";

/**
 * Efface les coordonnées du tunnel et prévient les consommateurs en mémoire.
 * Ne lève jamais : un stockage indisponible (navigation privée, quota) ne doit
 * pas faire échouer une déconnexion.
 */
export function clearStoredBookingContact(): void {
  try {
    sessionStorage.removeItem(BOOKING_CONTACT_STORAGE_KEY);
  } catch (error) {
    console.warn("[bookingContact] purge du stockage impossible:", error);
  }
  try {
    window.dispatchEvent(new Event(BOOKING_CONTACT_CLEARED_EVENT));
  } catch {
    // Environnement sans `window` (rendu serveur) : rien à prévenir.
  }
}
